module.exports = __webpack_public_path__ + "img/beanie.593d38a8.png";